import { z } from "zod";

export const uuidSchema = z.string().uuid();

export const emailSchema = z.string().email().min(5).max(254);

export const passwordSchema = z
	.string()
	.min(12, "Password must be at least 12 characters")
	.max(128, "Password must be at most 128 characters")
	.regex(/[A-Z]/, "Password must contain an uppercase letter")
	.regex(/[a-z]/, "Password must contain a lowercase letter")
	.regex(/[0-9]/, "Password must contain a number")
	.regex(/[^A-Za-z0-9]/, "Password must contain a special character");

export const registerSchema = z.object({
	email: emailSchema,
	password: passwordSchema,
	firstName: z.string().min(1).max(100),
	lastName: z.string().min(1).max(100),
});

export const loginSchema = z.object({
	email: emailSchema,
	password: z.string().min(1).max(128),
});

export const forgotPasswordSchema = z.object({
	email: emailSchema,
});

export const resetPasswordSchema = z.object({
	token: z.string().min(1),
	password: passwordSchema,
});

export const paginatedQuerySchema = z.object({
	cursor: z.string().optional(),
	limit: z.coerce.number().min(1).max(200).default(50),
	sortBy: z.string().optional(),
	sortOrder: z.enum(["asc", "desc"]).default("desc"),
});

export type RegisterInput = z.infer<typeof registerSchema>;
export type LoginInput = z.infer<typeof loginSchema>;
export type ForgotPasswordInput = z.infer<typeof forgotPasswordSchema>;
export type ResetPasswordInput = z.infer<typeof resetPasswordSchema>;
export type PaginatedQuery = z.infer<typeof paginatedQuerySchema>;

export * from "./sales";
export * from "./sync";
